// validateServiceType() vẫn giữ nguyên bit-check - KHÔNG phải để đọc Organization.service_type nữa
// (đã gộp hết 4 bit về organization_module_settings, xem getServiceTypes() bên dưới) mà vì
// MainPage/News.js đang tái dùng đúng hàm này cho service_type CỦA CATEGORY (bảng khác, ý nghĩa
// khác hẳn, không liên quan gì Organization/organization_module_settings) - không đụng vào.
export const validateServiceType = (_type = '0000000000000000', _service_name) => {
    if (!!!_type) _type = "";
    if (_service_name === 'channel' && _type.substring(0, 1) === '1') return true

    return false
}

// Permissions "-allowable" cho Organization/Settings (routes.js, Settings.js) - giờ đi thẳng qua
// enabled_module_features (organization_module_settings, nguồn thật duy nhất - xem
// config/organization_features.php) cho CẢ channel lẫn product, không còn đọc bit service_type nào
// của Organization nữa. Tham số _type giữ lại (không xoá) chỉ để không phải sửa call site nếu sau
// này còn cần, nhưng hiện không dùng.
export const getServiceTypes = (_type, enabledModuleFeatures = []) => {
    const enabled = enabledModuleFeatures || []
    let _service_names = {}
    if (enabled.includes('channel'))
        _service_names = {..._service_names, 'channel-allowable': true}
    if (enabled.includes('product'))
        _service_names = {..._service_names, 'product-allowable': true}

    return _service_names
}
